import React, { FC } from "react";

import {
  useSearchManagersKpiTerms,
  useApisManagersKpiTermsIndex,
} from "~/hooks";

import { TabItemLinks } from "~/components/atoms";
import {
  EmployeeLayout,
  EmployeeLayoutMainContent,
} from "~/components/layouts";
import { ManagersKpiTermsIndexTemplate } from "~/components/templates";

export const ManagersKpiTermsIndex: FC = () => {
  const {
    kpiTerms,
    keyword,
    isLoading,
    hasNextPage,
    startDate,
    endDate,
    selectableDropdownPublicStatusIds,
    selectedDropdownPublicStatusId,
    selectableDropdownDivisions,
    selectedDropdownDivisions,
    selectableDropdownSections,
    selectedDropdownSections,
    onDivisionChange,
    onSectionChange,
    unshiftItem,
    findAndRemove,
    onChangeDropdownPublicStatusId,
    fetchNextPage,
    onChangeDateRange,
    onChangeKeyword,
    onConditionReset,
    onSearchSubmit,
  } = useSearchManagersKpiTerms({
    useApisKpiTerms: useApisManagersKpiTermsIndex,
  });

  const breadCrumbItems = [
    { label: "KPI・KGI", href: "/managers/kpi_terms" },
    { label: "一覧", href: "/managers/kpi_terms" },
  ];

  return (
    <EmployeeLayout withRightSidebar={false} breadCrumbItems={breadCrumbItems}>
      <EmployeeLayoutMainContent withRightSidebar={false}>
        <TabItemLinks
          items={[
            {
              name: "チームに蓄積",
              href: "/managers/kpi_terms",
              isActive: true,
            },
            {
              name: "過去所属先での対応含む",
              href: "/managers/belonging_employees/kpi_terms",
              isActive: false,
            },
          ]}
        />
        <ManagersKpiTermsIndexTemplate
          className="mt-8"
          kpiTerms={kpiTerms}
          keyword={keyword}
          isLoading={isLoading}
          hasNextPage={hasNextPage}
          startDate={startDate}
          endDate={endDate}
          selectableDropdownPublicStatusIds={selectableDropdownPublicStatusIds}
          selectedDropdownPublicStatusId={selectedDropdownPublicStatusId}
          selectableDropdownDivisions={selectableDropdownDivisions}
          selectedDropdownDivisions={selectedDropdownDivisions}
          selectableDropdownSections={selectableDropdownSections}
          selectedDropdownSections={selectedDropdownSections}
          onDivisionChange={onDivisionChange}
          onSectionChange={onSectionChange}
          unshiftItem={unshiftItem}
          onChangeDropdownPublicStatusId={onChangeDropdownPublicStatusId}
          onChangeDateRange={onChangeDateRange}
          fetchNextPage={fetchNextPage}
          findAndRemove={findAndRemove}
          onChangeKeyword={onChangeKeyword}
          onSearchSubmit={onSearchSubmit}
          onConditionReset={onConditionReset}
        />
      </EmployeeLayoutMainContent>
    </EmployeeLayout>
  );
};
